module.exports = __webpack_public_path__ + "img/AL.3be3b0e1.svg";